// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Cu-P","file":"styles_file__339o1"};